var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { createFetcher, defaultFetch } from '@lucidlink/sdk/fetcher';
import { DEPENDENCY_KEYS, useDependency } from '#context';
export const useAwsContractCreation = ({ onError, onSettled, onSuccess, } = {}) => {
    _react_refresh_temp_1();
    const webServiceEndpoint = useDependency(DEPENDENCY_KEYS.WEB_SERVICE_ENDPOINT);
    const mutation = useMutation({
        mutationFn: async (contractData) => {
            const fetcher = createFetcher({
                baseUrl: webServiceEndpoint,
                baseUrlHasVersion: true,
                fetch: defaultFetch,
            });
            return await fetcher.post(['testing', 'mock-aws-contract'], {
                body: contractData,
            });
        },
        onSuccess: (data) => {
            if (typeof onSuccess === 'function') {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (typeof onError === 'function') {
                onError(error);
            }
        },
        onSettled: () => {
            if (typeof onSettled === 'function') {
                onSettled();
            }
        },
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useAwsContractCreation, "68blas1aZXyiiV4KHjO0G2Dn8BY=", false, () => [useDependency, useMutation]);
